const styles = theme => ({
  progressContainer: {
    height: "calc(100vh - 64px)",
    [theme.breakpoints.down("xs")]: {
      height: "calc(100vh - 56px)",
    },
  },
  progressItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
})

export default styles
